import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Target, Heart, MapPin } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50" data-testid="about-page">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-gray-800 text-white py-20 relative overflow-hidden">
        {/* Background Logo Watermark */}
        <div className="absolute inset-0 flex items-center justify-center opacity-10">
          <img 
            src="/logo.png" 
            alt="" 
            className="w-auto h-[400px] object-contain"
          />
        </div>
        
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <h1 className="text-5xl font-bold mb-6" data-testid="about-title">
            A Higher Standard for Short-Term Rentals
          </h1>
          <p className="text-xl text-blue-100">
            Redefining luxury accommodations across California and Arizona
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto px-4 py-16">
        <div className="bg-white rounded-xl shadow-lg p-12 mb-12">
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            SanchezbnbprestigeLLC was founded to redefine short-term rentals through quality, consistency, and attention to detail across multiple markets.
          </p>
          <p className="text-xl text-gray-700 leading-relaxed">
            From Sacramento to Los Angeles, San Bernardino County, and Arizona, our properties are curated to deliver a refined, stress-free experience for business travelers, families, and discerning guests seeking premium accommodations.
          </p>
        </div>

        {/* Our Locations */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Our Locations</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <MapPin className="h-6 w-6 text-blue-600" />
                <h3 className="text-2xl font-bold text-gray-900">Sacramento</h3>
              </div>
              <p className="text-gray-600">
                California's capital city, offering a blend of historic charm and modern convenience.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <MapPin className="h-6 w-6 text-blue-600" />
                <h3 className="text-2xl font-bold text-gray-900">Los Angeles</h3>
              </div>
              <p className="text-gray-600">
                The entertainment capital, providing access to beaches, culture, and world-class dining.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <MapPin className="h-6 w-6 text-blue-600" />
                <h3 className="text-2xl font-bold text-gray-900">San Bernardino County</h3>
              </div>
              <p className="text-gray-600">
                Gateway to Southern California's scenic beauty and outdoor adventures.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <MapPin className="h-6 w-6 text-blue-600" />
                <h3 className="text-2xl font-bold text-gray-900">Arizona</h3>
              </div>
              <p className="text-gray-600">
                Desert landscapes, vibrant cities, and year-round sunshine.
              </p>
            </div>
          </div>
        </div>

        {/* Our Values */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">What Sets Us Apart</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Award className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Premium Quality</h3>
              <p className="text-gray-600">
                Every property is professionally maintained to hospitality standards.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Target className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Consistency</h3>
              <p className="text-gray-600">
                The same elevated experience across all our locations.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Heart className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Guest Care</h3>
              <p className="text-gray-600">
                24/7 support and attention to detail in every interaction.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-blue-900 rounded-xl p-12 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Ready to Book Your Stay?</h2>
          <p className="text-xl text-blue-100 mb-8">
            Experience the SanchezbnbprestigeLLC difference
          </p>
          <Link
            to="/properties"
            className="inline-block bg-white text-blue-600 hover:bg-blue-50 px-8 py-3 rounded-lg font-semibold transition-colors"
            data-testid="about-cta-button"
          >
            View Our Properties
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;